import { MessageCircle } from "lucide-react";
import { Reveal, SectionHeading } from "./Reveal";
import { PRICING, whatsappLink, DEFAULT_WA_MESSAGE } from "../data/site";

export const Pricing = () => (
    <section id="prezzi" data-testid="pricing-section" className="py-24 sm:py-36">
        <div className="max-w-7xl mx-auto px-5 sm:px-8">
            <SectionHeading
                index="03"
                eyebrow="Prezzi"
                title="Prezzi chiari, senza sorprese."
                testId="pricing-heading"
            />
            <Reveal delay={0.1}>
                <p className="mt-6 text-white/70 max-w-2xl leading-relaxed">
                    Un confronto onesto tra i prezzi medi in Italia e i nostri.
                    Il preventivo definitivo è sempre gratuito e personalizzato
                    sulla tua panoramica.
                </p>
            </Reveal>

            <div className="mt-14">
                <Reveal>
                    <div className="hidden sm:grid grid-cols-[1fr_auto_auto] gap-x-10 pb-4 text-xs uppercase tracking-[0.2em] text-white/40">
                        <span>Trattamento</span>
                        <span className="w-40 text-right">In Italia</span>
                        <span className="w-40 text-right text-gold">A Valona</span>
                    </div>
                </Reveal>

                {PRICING.map((row, i) => (
                    <Reveal key={row.treatment} delay={i * 0.06}>
                        <div
                            data-testid={`pricing-row-${i}`}
                            className="grid grid-cols-1 sm:grid-cols-[1fr_auto_auto] gap-y-2 gap-x-10 py-7 border-t border-white/10 items-baseline last:border-b"
                        >
                            <h3 className="font-display text-xl sm:text-2xl text-white font-light">
                                {row.treatment}
                            </h3>
                            <p className="sm:w-40 sm:text-right text-white/40 line-through text-sm sm:text-base">
                                <span className="sm:hidden not-italic text-white/30 uppercase tracking-widest text-xs mr-2">Italia</span>
                                {row.italy}
                            </p>
                            <p className="sm:w-40 sm:text-right font-display text-2xl sm:text-3xl text-gold">
                                <span className="sm:hidden text-white/30 uppercase tracking-widest text-xs mr-2 font-sans not-italic">Valona</span>
                                {row.valona}
                            </p>
                        </div>
                    </Reveal>
                ))}
            </div>

            <Reveal delay={0.15}>
                <div className="mt-12 rounded-2xl border border-gold/30 bg-[radial-gradient(ellipse_at_top,rgba(212,175,55,0.08),transparent_70%)] p-8 sm:p-12 flex flex-col sm:flex-row sm:items-center justify-between gap-8">
                    <div>
                        <p className="font-display text-3xl sm:text-4xl font-light text-white">
                            Risparmia fino al{" "}
                            <span className="italic text-gold">70%</span>
                        </p>
                        <p className="mt-3 text-white/60 text-sm max-w-md">
                            Prezzi indicativi. Inviaci la panoramica: il preventivo
                            preciso è gratuito e arriva entro 24 ore.
                        </p>
                    </div>
                    <a
                        href={whatsappLink(DEFAULT_WA_MESSAGE)}
                        target="_blank"
                        rel="noopener noreferrer"
                        data-testid="pricing-cta-whatsapp"
                        className="shrink-0 inline-flex items-center justify-center gap-3 px-8 py-4 rounded-full bg-wa text-black text-sm font-semibold uppercase tracking-[0.12em] hover:scale-[1.03] transition-transform duration-300"
                    >
                        <MessageCircle size={18} />
                        Richiedi preventivo
                    </a>
                </div>
            </Reveal>
        </div>
    </section>
);
